import { FormEvent, useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setAuth } from "../redux/auth/auth.slice";
import { setSession } from "../auth/auth.utils";
import {
  sendOtpToEmail,
  verifyOtpCode,
  loginByGoogleWithFirebase
} from "../services/auth.service";
import { Paths } from "../routes/paths";
import { LoginHeader } from "../components/LoginHeader";
import { signInWithPopup } from "firebase/auth";
import { auth, provider } from "../services/firebase";
import axiosInstance from "../services/axios";
import styles from "./css/LoginPage.module.css";
import { Footer } from "../components/footer";
import { ROLE_TYPES, API_ENDPOINTS } from "../constants/api";
import { useFormState } from "../hooks/useFormState";
import { useSavedCredentials } from "../hooks/useSavedCredentials";
import { loadFeatures } from "../auth/auth.utils";


export const LoginPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, error, setLoading, setError, clearError } = useFormState();
  const { savedEmails, savedUserIds, saveEmail, saveUserId } = useSavedCredentials();
  const containerRef = useRef<HTMLDivElement>(null);

  const [step, setStep] = useState<"email" | "otp">("email");
  const [email, setEmail] = useState("");
  const [id, setId] = useState("");
  const [code, setCode] = useState("");

  useEffect(() => {
    // Add background image to the component container
    if (containerRef.current) {
      containerRef.current.style.backgroundImage = 'url("/Images/view1.png")';
      containerRef.current.style.backgroundSize = 'cover';
      containerRef.current.style.backgroundPosition = 'center';
      containerRef.current.style.backgroundRepeat = 'no-repeat';
      containerRef.current.style.minHeight = '100vh';
      containerRef.current.style.width = '100%';
    }
    
    // Also apply to body as a fallback
    document.body.style.backgroundImage = 'url("/Images/view1.png")';
    document.body.style.backgroundSize = 'cover';
    document.body.style.backgroundPosition = 'center';
    document.body.style.backgroundRepeat = 'no-repeat';
    document.body.style.backgroundAttachment = 'fixed';
    
    return () => {
      // Clean up body styles when component unmounts
      document.body.style.backgroundImage = '';
      document.body.style.backgroundSize = '';
      document.body.style.backgroundPosition = '';
      document.body.style.backgroundRepeat = '';
      document.body.style.backgroundAttachment = '';
    };
  }, []);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    clearError();

    // שמירת המייל ות"ז ב-localStorage
    saveEmail(email);
    saveUserId(id);
    
    try {
      if (step === "email") {
        await sendOtpToEmail(email, id);
        setStep("otp");
      } else {
        const { token } = await verifyOtpCode(email, code, id);

        if (!token) {
          setError("לא התקבל טוקן תקף.");
          return;
        }

        setSession(token);
        axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        await loadFeatures(dispatch);

        const profileResponse = await axiosInstance.get(API_ENDPOINTS.login.PROFILE);
        const userData = profileResponse.data;

        if (!userData?.id || !userData?.role) {
          setError("הקוד אומת אך המשתמש לא קיים במערכת.");
          return;
        }

        dispatch(setAuth({
          id: userData.id,
          email: userData.email,
          role: userData.role,
          name: `${userData.firstName} ${userData.lastName}`,
        }));

        switch (userData.role) {
          case ROLE_TYPES.ADMIN:
            navigate(`/${Paths.adminArea}`);
            break;
          case ROLE_TYPES.ANALYST:
            navigate(`/${Paths.analystArea}`);
            break;
          case ROLE_TYPES.CHILD:
            navigate(`/${Paths.parentArea}`);
            break;
          default:
            navigate(`/${Paths.home}`);
            break;
        }
      }
    } catch (err: any) {
      const message = err?.response?.data || err?.message || "שגיאה כללית.";
      setError(message);
    }
  };

  const handleGoogleLogin = async () => {
    clearError();
    try {
      // ניקוי state קודם לפני ההתחברות
      setLoading(true);
      
      const result = await signInWithPopup(auth, provider);
      
      // ודא שהמשתמש אישר את ההתחברות
      if (!result || !result.user) {
        throw new Error("התחברות בוטלה או נכשלה");
      }

console.log("1. Start login");
const token = await result.user.getIdToken();

const response = await loginByGoogleWithFirebase(token);
console.log("3. Login API response:", response);
      console.log("Login response isIdCompleted:", response.isIdCompleted);
      
if (response.isIdCompleted === false) {
  navigate(`/${Paths.completeProfile}`, {
    state: { email: response.email }
  });
  return;
}

      setSession(response.token);
      axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${response.token}`;


      dispatch(setAuth({
        id: response.id,
        email: response.email,
        role: response.role,
        name: response.name,
      }));

      localStorage.setItem("token", response.token);
      await loadFeatures(dispatch);

      switch (response.role) {
        case ROLE_TYPES.ADMIN:
          navigate(`/${Paths.adminArea}`);
          break;
        case ROLE_TYPES.ANALYST:
          navigate(`/${Paths.analystArea}`);
          break;
        case ROLE_TYPES.CHILD:
          navigate(`/${Paths.parentArea}`);
          break;
        default:
          navigate(`/${Paths.home}`);
          break;
      }
    } catch (err: any) {
      // הסרת console.error לפרודקשן
      
      // טיפול בשגיאות ספציפיות של Firebase
      if (err.code === 'auth/popup-closed-by-user') {
        setError("חלון ההתחברות נסגר. אנא נסה שוב.");
      } else if (err.code === 'auth/popup-blocked') {
        setError("החלון נחסם על ידי הדפדפן. אנא אפשר חלונות קופצים ונסה שוב.");
      } else if (err.code === 'auth/network-request-failed') {
        setError("בעיית רשת. אנא בדק את החיבור לאינטרנט ונסה שוב.");
      } else {
        const message = err?.message || "התחברות עם גוגל נכשלה.";
        setError(message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.pageContainer} ref={containerRef} style={{
      backgroundImage: 'url("/Images/view1.png")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundAttachment: 'fixed',
      minHeight: '100vh',
      width: '100%'
    }}>
      <div className={styles.headerWrapper}>
        <LoginHeader />
      </div>
      
      <div className={styles.backgroundContainer}>
        <div className={styles.loginBox}>
          <h1>התחברות</h1>
          <form onSubmit={handleSubmit} className={styles.loginForm}>
            {/* {step === "email" ? (
              <>
                <div style={{ display: 'flex', gap: '25px', marginBottom: '15px' }}>
                  <input
                    type="email"
                    placeholder="אימייל"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className={styles.input}
                    required
                    autoComplete="email"
                    style={{ flex: 1 }}
                  />

                  <input
                    type="text"
                    placeholder="תעודת זהות"
                    value={id}
                    onChange={(e) => setId(e.target.value)}
                    className={styles.input}
                    required
                    style={{ flex: 1 }}
                  />
                </div>

                <button type="submit" className={styles.button}>
                  שלח קוד אימות
                </button>
              </>
            ) : (
              <>
                <div style={{ display: 'flex', gap: '25px', marginBottom: '15px' }}>
                  <input
                    placeholder="קוד אימות"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    className={styles.input}
                    required
                    style={{ flex: 1 }}
                  />
                  <button type="submit" className={styles.button} style={{ flex: 1 }}>
                    אמת והתחבר
                  </button>
                </div>
              </>
            )} */}

            {error && <p className={styles.error}>{error}</p>}

            {/* <div className={styles.divider}>או</div> */}
            <button
              type="button"
              className={`${styles.button} ${styles.googleButton}`}
              onClick={handleGoogleLogin}
              disabled={loading}
              style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                gap: '15px',
                padding: '15px',
                fontSize: '1.2rem'
              }}
            >
              {loading ? (
                <span>מתחבר...</span>
              ) : (
                <>
                  <img 
                    src="/Images/google-icon.svg" 
                    alt="Google"
                    className={styles.googleIcon} 
                  />
                  <span>התחברות עם Google</span>
                </>
              )}
            </button>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
};
